import { FC } from 'react';

import { Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { ScenarioForm } from '@/types/scenario';
import { normalizePositiveNumericValuesInput } from '@/utils';

type Props = {
  disabled?: boolean;
};

const FinancialMetrics: FC<Props> = ({ disabled = false }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Form.Item<ScenarioForm>
      className="p-16 pb-40"
      style={{
        border: '0.5px solid',
        borderRadius: '10px',
        borderColor: theme.colors.grayLightAccent,
      }}
      wrapperCol={{ span: 24 }}
    >
      <Row>
        <Col className="pr-8" span={12}>
          <Form.Item<ScenarioForm>
            normalize={normalizePositiveNumericValuesInput}
            name="taxRate"
            label={t('scenario.form.financialMetrics.taxRate')}
            rules={[
              {
                required: true,
                message: t('scenario.form.financialMetrics.taxRateRequired'),
              },
            ]}
          >
            <Input
              disabled={disabled}
              placeholder={t('scenario.form.financialMetrics.taxRate')}
              addonAfter="%"
            />
          </Form.Item>
        </Col>
        <Col className="pl-8" span={12}>
          <Form.Item<ScenarioForm>
            normalize={normalizePositiveNumericValuesInput}
            name="hurdleRate"
            label={t('scenario.form.financialMetrics.hurdleRate')}
            rules={[
              {
                required: true,
                message: t('scenario.form.financialMetrics.hurdleRateRequired'),
              },
            ]}
          >
            <Input
              disabled={disabled}
              placeholder={t('scenario.form.financialMetrics.hurdleRate')}
              addonAfter="%"
            />
          </Form.Item>
        </Col>
        <Col className="pr-8" span={12}>
          <Form.Item<ScenarioForm>
            normalize={normalizePositiveNumericValuesInput}
            name="batteryPriceDeclinePercentagePerYear"
            label={t(
              'scenario.form.financialMetrics.batteryPriceDeclinePercentagePerYear'
            )}
            rules={[
              {
                required: true,
                message: t(
                  'scenario.form.financialMetrics.batteryPriceDeclinePercentagePerYearRequired'
                ),
              },
            ]}
          >
            <Input
              disabled={disabled}
              placeholder={t(
                'scenario.form.financialMetrics.batteryPriceDeclinePercentagePerYear'
              )}
              addonAfter="%"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form.Item>
  );
};

export default FinancialMetrics;
